import BlogCategories from './BlogCategories';

export default BlogCategories;
